import React, { FC } from 'react'
import classNames from 'classnames'
import { motion } from 'framer-motion'
import { getImage } from '../../../../app/utlis/imageConstants'
import DynamicSVG from '../../../atoms/DynamicSvg/DynamicSvg'

interface HealthIdeaProjectsProps {
    healthCareData: any
}

const HealthIdeaProjects: FC<HealthIdeaProjectsProps> = ({ healthCareData }) => {
    return (
        <div>
            <div className='flex flex-col gap-8 md:gap-12 pt-8 md:pt-12 bg-blackDark'>
                {healthCareData.HealthcareIdeaProjectsData.map((projects: any, index: number) => {
                     let img = getImage(projects.image ?? "") ?? "";
                    return (
                        <motion.div 
                            key={index}
                            className='bg-darkGreyPrimary py-6 md:py-12 border-b-4 border-[#313131] last:border-0'
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: false, amount: 0.2 }}
                            transition={{ duration: 0.6, ease: "easeOut" }}
                        >
                            <div className={`flex flex-col md:flex-${projects.row} px-4 md:px-40 gap-6 md:gap-10 justify-between`}>
                                <motion.div 
                                    className={classNames('flex flex-col w-full md:w-2/4 border-l-2 pl-4 md:pl-6', `flex-${projects.row}`, `border-${projects.textColor}`)}
                                    initial={{ opacity: 0, x: -20 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    viewport={{ once: false, amount: 0.3 }}
                                    transition={{ duration: 0.5, ease: "easeOut" }}
                                >
                                    <motion.div 
                                        className={classNames('font-semibold text-2xl md:text-4xl', `text-${projects.textColor}`)}
                                        initial={{ opacity: 0 }}
                                        whileInView={{ opacity: 1 }}
                                        viewport={{ once: false }}
                                        transition={{ duration: 0.7 }}
                                    >
                                        {projects.title}
                                    </motion.div>
                                    <motion.div 
                                        className={classNames('text-greyQuaternary text-base md:text-lg pt-1 pb-8 md:pb-16', `text-${projects.text}`)}
                                        initial={{ opacity: 0 }}
                                        whileInView={{ opacity: 1 }}
                                        viewport={{ once: false }}
                                        transition={{ duration: 0.7, delay: 0.2 }}
                                    >
                                        {projects.subtitle}
                                    </motion.div>
                                    <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 justify-between`}>
                                        {projects.steps.map((project: any, stepIndex: number) => {
                                            return (
                                                <motion.div 
                                                    key={stepIndex}
                                                    className={`bg-${projects.textColor} rounded-[_1.8rem_2rem_2rem_1.8rem] p-[0px] pl-[2px]`}
                                                    initial={{ opacity: 0, y: 20 }}
                                                    whileInView={{ opacity: 1, y: 0 }}
                                                    viewport={{ once: false }}
                                                    transition={{ duration: 0.5, delay: 0.3 + (stepIndex * 0.1) }}
                                                    whileHover={{ scale: 1.03 }}
                                                >
                                                    <div className='bg-blackDark p-4 md:p-6 rounded-3xl font-bold text-lg md:text-xl relative overflow-hidden h-[100%] flex items-center justify-start'>{project.title}</div>
                                                </motion.div>
                                            )
                                        })}
                                    </div>
                                </motion.div>
                                <motion.div 
                                    className={`bg-blackDark w-full md:w-[40%] md:h-[450px] h-auto rounded-xl flex items-center justify-center`}
                                    initial={{ opacity: 0, scale: 0.9 }}
                                    whileInView={{ opacity: 1, scale: 1 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                    transition={{ duration: 0.6, ease: "easeOut" }}
                                >
                                    {/* <img src={projects.image} className="w-[60%] md:w-[60%] h-auto" /> */}
                                    <DynamicSVG color='#fff' size='w-full h-full'>{img}</DynamicSVG>
                                </motion.div>
                            </div>
                        </motion.div>
                    )
                })}
            </div>
        </div>
    )
}

export default HealthIdeaProjects

